import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { breakpoints, palette, spacing, Text, typography } from 'main/ui'

interface IContainerProps {
  imageUrl: string | null
}

const colorBackgroundStyles = css`
  background-color: rgba(40, 50, 90);
`

function imageBackgroundStyles(imageUrl: string) {
  return css`
    background: linear-gradient(rgba(40, 50, 90, 0.6), rgba(40, 50, 90, 0.6)), url('${imageUrl}');
    background-position: center;
    background-size: cover;
  `
}

export const Container = styled.div<IContainerProps>`
  ${({ imageUrl }) => (imageUrl ? imageBackgroundStyles(imageUrl) : colorBackgroundStyles)}

  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 340px;
  justify-content: center;
  padding: ${spacing.majorScale(4)}px 0;
  width: 100%;
`

export const SchoolName = styled.h1`
  color: ${palette.white};
  font-size: 48px;
  font-weight: ${typography.fontWeight.bold};
  font-family: ${typography.fontFamily.ui};
  line-height: 60px;
  padding: 0 ${spacing.majorScale(3)}px;
  text-align: center;
`

export const Tagline = styled(Text)`
  box-sizing: border-box;
  color: ${palette.white};
  font-size: 20px;
  font-weight: ${typography.fontWeight.bold};
  line-height: 30px;
  padding: 0 ${spacing.majorScale(3)}px;
  margin-top: ${spacing.majorScale(2)}px;
  max-width: ${breakpoints.sm}px;
  text-align: center;

  @media (min-width: ${breakpoints.lg}px) {
    max-width: 650px;
  }
`
